<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="qr-stage">
        <div class="qr-grid">
          <span
            v-for="cell in cells"
            :key="cell.i"
            class="qr-cell"
            :class="{ '--on': cell.on, '--eye': cell.eye }"
          ></span>
          <span class="qr-eye qr-eye--tl"></span>
          <span class="qr-eye qr-eye--tr"></span>
          <span class="qr-eye qr-eye--bl"></span>
        </div>
        <div class="qr-label">
          <span class="qr-bar qr-bar--md"></span>
          <span class="qr-bar qr-bar--sm"></span>
        </div>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

const SIZE = 11

function buildCells() {
  const out: { i: number; on: boolean; eye: boolean }[] = []
  // Stable pseudo-random pattern
  const seed = [3, 7, 11, 17, 23, 29, 37, 41]
  for (let i = 0; i < SIZE * SIZE; i++) {
    const r = Math.floor(i / SIZE)
    const c = i % SIZE
    const inEye =
      (r < 3 && c < 3) || (r < 3 && c > SIZE - 4) || (r > SIZE - 4 && c < 3)
    const on = !inEye && (i * seed[i % seed.length]) % 5 < 2
    out.push({ i, on, eye: inEye })
  }
  return out
}

export default Vue.extend({
  name: 'PreviewQrCode',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  data() {
    return { cells: buildCells() }
  },
})
</script>

<style scoped lang="scss">
.qr-stage {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  min-height: 150px;
}
.qr-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(11, 1fr);
  gap: 1px;
  width: 110px;
  height: 110px;
  background: white;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid rgba(15, 15, 20, 0.1);
}
.qr-cell {
  background: transparent;
  border-radius: 1px;
}
.qr-cell.--on { background: #0F0F14; }
.qr-cell.--eye { background: transparent; }
.qr-eye {
  position: absolute;
  width: 22px;
  height: 22px;
  border: 3px solid #0F0F14;
  border-radius: 4px;
  background: white;
}
.qr-eye::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px;
  height: 6px;
  background: #0F0F14;
  border-radius: 1px;
  transform: translate(-50%, -50%);
}
.qr-eye--tl { top: 6px; left: 6px; }
.qr-eye--tr { top: 6px; right: 6px; }
.qr-eye--bl { bottom: 6px; left: 6px; }
.qr-label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 80px;
}
.qr-bar {
  display: block;
  height: 8px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.12);
}
.qr-bar--md { width: 90%; background: rgba(15, 15, 20, 0.22); }
.qr-bar--sm { width: 60%; }
</style>
